import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "filterable-list__load-more-wrapper" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("span", { class: "filterable-list__load-more-loader" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "filterable-list__load-more-loader-box is-one" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "filterable-list__load-more-loader-box is-two" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "filterable-list__load-more-loader-box is-three" })
], -1 /* HOISTED */);
const _hoisted_3 = { class: "filterable-list__load-more-text" };
import { useNewsFilter, useI18n } from "../features";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NewsListMoreButton',
    setup(__props) {
        const { canLoadMore, loadMore } = useNewsFilter();
        const { t } = useI18n();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_unref(canLoadMore))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "filterable-list__load-more",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_unref(loadMore) && _unref(loadMore)(...args)))
                    }, [
                        _hoisted_2,
                        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('more')), 1 /* TEXT */)
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
